import { render } from "./FtpUpload.vue?vue&type=template&id=01df84b9&scoped=true"
import script from "./FtpUpload.vue?vue&type=script&lang=js"
export * from "./FtpUpload.vue?vue&type=script&lang=js"

import "./FtpUpload.vue?vue&type=style&index=0&id=01df84b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01df84b9"]])

export default __exports__